"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _utils = require("../../../utils");
var _getBordersStyles = _interopRequireWildcard(require("../../../utils/getBordersStyles"));
var _Typography = _interopRequireDefault(require("../../atoms/Typography"));
var _Icon = _interopRequireDefault(require("../../atoms/Icon"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  disabled: false,
  width: '100%',
  loadedFile: null
};
function InputFileUploader(props) {
  const {
    width,
    accept,
    disabled,
    onChange,
    styles,
    loadedFile
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const {
    colors
  } = (0, _react2.useTheme)();
  const inputRef = (0, _react.useRef)();
  const onLoadFileDialog = () => {
    var _inputRef$current;
    if (disabled) return;
    inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.click();
  };
  (0, _react.useEffect)(() => {
    if (!Boolean(loadedFile)) {
      if (inputRef !== null && inputRef !== void 0 && inputRef.current) inputRef.current.value = '';
    }
  }, [loadedFile]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(Uploader, {
    width: width,
    onClick: onLoadFileDialog,
    styles: styles
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "upload",
    size: 30,
    color: colors.MAIN.PRIMARY
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    size: 12,
    weight: 700,
    color: colors.MAIN.PRIMARY
  }, "Subir archivo"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    size: 10,
    color: colors.MAIN.PRIMARY
  }, "Tama\xF1o m\xE1ximo: 2 mb"))), /*#__PURE__*/_react.default.createElement(HiddenInput, {
    ref: inputRef,
    type: "file",
    accept: accept,
    onChange: event => {
      if (event.target.files && event.target.files[0]) {
        onChange === null || onChange === void 0 || onChange(event.target.files[0]);
      }
    }
  }));
}
const HiddenInput = _styled.default.input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: none;\n"])));
const Uploader = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n  padding: 15px 10px;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  border-radius: 7px;\n  cursor: pointer;\n\n  background: ", ";\n  ", "\n\n  @media screen and (min-width: 678px) {\n    width: 100%;\n    padding: 15px 25px;\n    align-items: center;\n\n    div {\n      display: flex;\n      width: 100%;\n      justify-content: space-between;\n    }\n\n    p:first-of-type {\n      font-size: 14px;\n    }\n\n    p:last-of-type {\n      font-size: 12px;\n    }\n  }\n\n  ", "\n"])), _ref => {
  let {
    width
  } = _ref;
  return width;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return (0, _utils.hexToRGBA)(theme.colors.MAIN.PRIMARY, 0.1);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return (0, _getBordersStyles.default)(1, _getBordersStyles.BorderTypes.Dashed, theme.colors.MAIN.PRIMARY);
}, _ref4 => {
  let {
    styles
  } = _ref4;
  return styles;
});
var _default = exports.default = InputFileUploader;